import React from 'react';
import { Link } from '../../../RouterCompatibility';
import { createSelector } from 'reselect';
import TreeGoalActions from '../../../TreeGoalActions/TreeGoalActions';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import { getPath } from '../../../../utils/Router';
import helperColumns from '../../../DataComponent/helper';
import {
    getConversionStatus
} from '../../../../helpers/common';

const conversions = (state) => {
    return state.conversions.list
};
const serverStore = (state) => state.serverStorage.store;
const totalPages = (state) => state.conversionsTotal.totalPages;
const totalItems = (state) => state.conversionsTotal.totalItems;

export const getTotalPages = createSelector(
    totalPages,
    (totalPages = []) => {
        return totalPages;
    }
);

export const getTotalItems = createSelector(
    totalItems,
    (totalItems = []) => {
        return totalItems;
    }
);

export const mainSelector = createSelector(
    conversions,
    (conversions = []) => {
        let list = [];

        (conversions || []).forEach((item, i) => {
            try {
                const conversionPath = getPath('conversion', {id: item.ConversionId});
                const conversionInfo = item.ConversionInfo ? JSON.parse(item.ConversionInfo) : null;
                list.push({
                    id: <Link to={conversionPath}>{item.ConversionId}</Link>,
                    createdAt: item.ConversionDateTime,
                    updatedAt: item.FactDateTime,
                    status: getConversionStatus(item.FactStatus),
                    rejectReason: null !== conversionInfo && conversionInfo.reason ? conversionInfo.reason : item.ConversionRejectReason,
                    timeFromTrackToAction: I18nFormatter.fromDate(helperColumns.toTimestamp(item.TrackDateTime), helperColumns.toTimestamp(item.ConversionDateTime)),
                    advCid: item.AdvertiserUID,
                    goalTitle: <TreeGoalActions data={[{...item}]} nestingLevel={2} />,
                    goalActions: <TreeGoalActions data={[{...item}]} />,
                    typeAction: item.GoalActionActionType,
                    saleSum: I18nFormatter.currency(item.SaleSumAmount, item.SaleSumCurrency, true),
                    publisherCreditPerLead: I18nFormatter.currency(item.PublisherCreditPerLeadAmount + item.DynamicCpaAmountReduced + item.DynamicCprAmountReduced, item.PublisherCreditPerLeadCurrency, true),
                    publisherCreditPerSale: I18nFormatter.currency(item.PublisherCreditPerSaleAmount - (null !== item.AdminFeePerSaleAmountReduced ? item.AdminFeePerSaleAmountReduced : 0), item.PublisherCreditPerSaleCurrency, true),
                    createdAtTrack: I18nFormatter.fullDateTime(+helperColumns.toTimestamp(item.TrackDateTime)),
                    ip: item.Ip,
                    utm_source: item.UtmSource,
                    utm_medium: item.UtmMedium,
                    utm_campaign: item.UtmCampaign,
                    utm_term: item.UtmTerm,
                    utm_content: item.UtmContent,
                    param1: item.Param1,
                    param2: item.Param2,
                    param3: item.Param3,
                    param4: item.Param4,
                    actions: {'i': i, 'id': item.ConversionId, 'path': conversionPath, 'status': item.FactStatus}
                });
            } catch (error) {
                console.error(error);
            } 
        });

        return list;
    }
);

export const getHeaderName = createSelector(
    serverStore,
    (serverStore) => {
        return helperColumns.getDate('conversions');
    }
);
